<template>
  <!-- 充电订单 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="通道">
        <el-input placeholder="通道号" v-model="filter.gunNo" clearable @input="handleInput" style="width: 90px"></el-input>
      </el-form-item>
      <el-form-item label="电表地址">
        <el-input placeholder="电表地址" v-model="filter.fee_table_address" clearable style="width: 140px"></el-input>
      </el-form-item>
      <!-- <el-form-item label="手机号">
        <el-input placeholder="手机号" v-model="filter.wx_phone" clearable style="width: 140px"></el-input>
      </el-form-item> -->
      <el-form-item label="对齐状态">
        <el-select class="selScale" v-model="filter.dev_balance_error" clearable style="width: 110px">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="异常" value="true"> </el-option>
          <el-option label="正常" value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker v-model="filter.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="资产码" prop="assets_code" width="220" align="center"></el-table-column>
      <el-table-column label="通道" prop="order_num" width="60" align="center"></el-table-column>
      <el-table-column label="余额" prop="dev_balance_real" width="90" align="center"></el-table-column>
      <el-table-column label="绑定" prop="is_band" width="60" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.user_bind">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="对齐" prop="dev_balance_error" width="60" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="!row.dev_balance_error">是</el-tag>
          <el-tag type="danger" v-else>异常</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="微信手机号" prop="wx_nick_name" width="110" align="center"></el-table-column> -->
      <el-table-column label="所属分支箱" prop="branch_box_name" align="center"></el-table-column>

      <el-table-column label="电表地址" prop="address" align="center"></el-table-column>
      <!-- <el-table-column label="车牌" prop="car_no" align="center"></el-table-column>
      <el-table-column label="车位" prop="park_no" align="center"></el-table-column> -->

      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <!-- <el-table-column label="修改时间" prop="modify_time" align="center"></el-table-column> -->
      <el-table-column label="余额时间" prop="balance_refresh_time" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
          <el-button type="text" v-if="row.dev_balance_error" @click="onBalanceForceDq(row)" v-permision_tjtf="'balance'">对齐</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="公共桩通道详情" width="800px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <!-- 第一列 -->
              <el-col :span="12">
                <el-form-item label="ID" prop="ID">
                  <el-input v-model="detailForm.ID" readonly disabled />
                </el-form-item>

                <el-form-item label="余额" prop="dev_balance_real">
                  <el-input v-model="detailForm.dev_balance_real" readonly disabled />
                </el-form-item>
                
                <el-form-item label="是否绑定" prop="is_band">
                  <span>{{ detailForm.is_band === 1 ? "是" : "否" }}</span>
                </el-form-item>

                <el-form-item label="所属分支箱编号" prop="power_branch_box_id">
                  <el-input v-model="detailForm.power_branch_box_id" readonly disabled />
                </el-form-item>

                <el-form-item label="通道" prop="order_num">
                  <el-input v-model="detailForm.order_num" readonly disabled />
                </el-form-item>

                <el-form-item label="地址" prop="address">
                  <el-input v-model="detailForm.address" readonly disabled />
                </el-form-item>

                <el-form-item label="描述" prop="remark">
                  <el-input v-model="detailForm.remark" readonly disabled />
                </el-form-item>
              </el-col>

              <!-- 第二列 -->
              <el-col :span="12">
                <el-form-item label="原因" prop="reason">
                  <el-input v-model="detailForm.reason" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="余额更新时间" prop="balence_query_reply_time">
                  <el-input v-model="detailForm.balence_query_reply_time" readonly disabled />
                </el-form-item> -->

                <el-form-item label="创建时间" prop="create_time">
                  <el-input v-model="detailForm.create_time" readonly disabled />
                </el-form-item>

                <el-form-item label="修改时间" prop="modify_time">
                  <el-input v-model="detailForm.modify_time" readonly disabled />
                </el-form-item>

                <el-form-item label="分支箱名称" prop="branch_box_name">
                  <el-input v-model="detailForm.branch_box_name" readonly disabled />
                </el-form-item>

                <el-form-item label="资产码" prop="assets_code">
                  <el-input v-model="detailForm.assets_code" readonly disabled />
                </el-form-item>
                
                <el-form-item label="扩展参数" prop="extendParam">
                  <el-input v-model="detailForm.extendParam" readonly disabled />
                </el-form-item>
                <!-- <el-form-item label="充值金额" prop="balance">
                  <el-input v-model="detailForm.balance" />
                </el-form-item>

                <el-button type="primary" size="mini" @click="onRechargeBalance">充值test</el-button>
                <el-button type="primary" size="mini" @click="onQueryBalance">余额查询test</el-button> -->
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
    <balanceForceDq ref="childForceDq"></balanceForceDq>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
//import { GetDevBalancePageList } from "@/api/dev_data_view"
import { getFeeTableIsPubPageListApi } from "@/api/dev_archive"
import { Send_FeeTable_BalanceRecharge, Send_FeeTable_QueryDevBalance, Send_FeeTable_BalanceForceDq } from "@/api/dev_send_order"
//import balanceForceDq from "./components/_balance_force_dq.vue"
import balanceForceDq from "@/views/dev_data/components/_balance_force_dq.vue"
import { mapGetters } from "vuex"
export default {
  name: "PubChargePileChannel",
  mixins: [pageMixin],
  components: { fileUpload, balanceForceDq },
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      visible: {
        editGroup: false
      },
      tableData: [],
      filter: {
        assets_code: "",
        fee_table_address: "",
        dev_balance_error: "",
        wx_phone: "",
        gunNo: "",
        dateRange: [] // 使用一个数组来同时存储开始和结束时间
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },
    getData() {
      this.loading = true
      console.log("this.filter.dateRange", this.filter.dateRange)
      getFeeTableIsPubPageListApi({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        start_time: !this.filter.dateRange || this.filter.dateRange.length == 0 ? "" : this.filter.dateRange[0],
        end_time: !this.filter.dateRange || this.filter.dateRange.length == 0 ? "" : this.filter.dateRange[1],
        assets_code: this.filter.assets_code || null,
        fee_table_address: this.filter.fee_table_address || null,
        gunNo: this.filter.gunNo || null,
        dev_balance_error: this.filter.dev_balance_error || null,
        wx_phone: this.filter.wx_phone || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        })
    },
    onRechargeBalance() {
      this.loading = true
      Send_FeeTable_BalanceRecharge({
        feetable_id: this.detailForm.ID,
        gunNo: this.detailForm.order_num,
        money: this.detailForm.balance,
        assets_code: this.detailForm.assets_code
      })
        .then((res) => {
          this.$message.success(res.msg)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        })
    },
    onBalanceForceDq(row) {
      this.$refs["childForceDq"].showForceDq(row)
    },
    onQueryBalance() {
      this.loading = true
      Send_FeeTable_QueryDevBalance({
        feetable_id: this.detailForm.ID,
        gunNo: this.detailForm.order_num,
        money: this.detailForm.balance,
        assets_code: this.detailForm.assets_code,
        fee_table_address: this.detailForm.fee_table_address
      })
        .then((res) => {
          this.$message.success(res.msg)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        })
    },
    onAdd(){
      
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
